import { useState, useEffect } from "react";
import axios from "axios";
import axiosCacheAdapter from "axios-cache-adapter";
import { useParams, useLocation } from "react-router-dom";
import PrivateImage from '../PrivateImage/PrivateImage';
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { set } from "lodash";


var baseUrl = 'https://dash.bestdiplomats.org';

const cache = axiosCacheAdapter.setupCache({
    maxAge: 5 * 60 * 1000,
});

const api = axios.create({
    adapter: cache.adapter,
});

var userEmail;
var JSToken;
var accessToken;
if (localStorage.user) {
    userEmail = localStorage.user_email;
    JSToken = JSON.parse(localStorage.user);
    accessToken = JSToken.access_token;
}

const config = {
    headers: { Authorization: `Bearer ${accessToken}` },
};

const statuses = [
    "Payment Pending",
    "Task Pending",
    "Task Submitted",
    "Rejected",
    "Approved",
    "Conference Selected",
    "Completed",
];

// Main Component
function ApplicationDetails() {
    const location = useLocation();
    const [applicationData, setApplicationData] = useState();
    const [taskData, setTaskData] = useState();
    const [loading, setLoading] = useState(true);
    const [availableStatuses, setAvailableStatuses] = useState();
    const { applicationID } = useParams();
    const { userData } = location.state || {};
    const navigate = useNavigate();
    const [destinations, setDestinations] = useState()
    const [selectedDestinations, setSelectedDestinations] = useState([]);
    const [disableSaveButton, setDisableSaveButton] = useState(false)
    const [originalStatus, setOriginalStatus] = useState();
    const [paymentReceipt, setPaymentReceipt] = useState(false);


    const handleCheckboxChange = (destination) => {
        setSelectedDestinations((prev) => {
            if (prev.find((d) => d.name === destination.name)) {
                return prev.filter((d) => d.name !== destination.name);
            } else {
                return [...prev, {
                    name: destination.name, title: destination.title, accommodation: "", non_accommodation: "",
                    image: destination.main_picture, start_date: destination.start_date, end_date: destination.end_date
                }];
            }
        });
    };

    const handlePriceChange = (destination, field, value) => {
        setSelectedDestinations((prev) =>
            prev.map((d) =>
                d.name === destination ? { ...d, [field]: value } : d
            )
        );
    };

    useEffect(() => {
        const fetchAllApplications = async () => {
            setLoading(true);
            try {
                const [applicationRes, taskRes, events] = await Promise.all([
                    api.get(
                        `https://dash.bestdiplomats.org/api/resource/Scholarship Application Requests?fields=["*"]&filters=[["name","=","${applicationID}"]]`,
                        config
                    ),
                    api.get(
                        `https://dash.bestdiplomats.org/api/method/get-assigned-tasks?email=${userData?.email}&application_id=${applicationID}`,
                        config
                    ),
                    api.get(
                        `https://dash.bestdiplomats.org/api/resource/Events?fields=["status","name","title","start_date","end_date","main_picture"]&filters=[["status","in",["Upcoming","Active"]]]`,
                        config
                    )

                ]);

                setApplicationData(applicationRes?.data?.data[0]);
                setOriginalStatus(applicationRes?.data?.data[0].application_status)
                setTaskData(taskRes?.data?.message[0]);
                setDestinations(events?.data?.data)
                if (applicationRes?.data?.data[0]?.destinations) {
                    const selected = JSON.parse(applicationRes?.data?.data[0]?.destinations);
                    console.log(selected)
                    setSelectedDestinations(selected);
                }
                if (applicationRes?.data?.data[0]?.application_status === 'Rejected') {
                    setAvailableStatuses(['Rejected']);
                }
                else {
                    const idx = statuses.indexOf(applicationRes?.data?.data[0]?.application_status);
                    const availableStatuses = idx === -1 ? statuses : statuses.slice(idx);
                    setAvailableStatuses(availableStatuses);
                }
                setLoading(false);

            } catch (e) {
                console.log(e);
                setLoading(false);
                navigate(-1);
                toast.error("Error fetching application data. Please try again.");
            }
        };
        fetchAllApplications();
    }, [applicationID]);

    const handleChange = (e, key) => {
        setApplicationData((prev) => ({ ...prev, [key]: e.target.value }));
    };

    const handleFeedbackChange = (key, value) => {
        setApplicationData((prev) => ({ ...prev, [key]: value }));
    };

    const submitChanges = async () => {
        if (applicationData?.application_status === "Conference Selected" && applicationData?.voucher
        ) {
            toast.error("Update the application status");
            return;
        }
        if (
            applicationData?.application_status === "Approved" &&
            selectedDestinations.length === 0
        ) {
            toast.error("Add destinations for selection");
            return;
        }
        if (selectedDestinations.length > 0) {
            const invalid = selectedDestinations.some(
                (d) => !d.accommodation || !d.non_accommodation
            );

            if (invalid) {
                toast.error("Please enter both accommodation and non-accommodation prices for all destinations");
                return;
            }
        }

        if (
            (applicationData?.application_status === "Completed" ||
                applicationData?.application_status === "Rejected") &&
            !applicationData?.voucher
        ) {
            toast.error("Add voucher code to complete application");
            return;
        }

        if (
            applicationData?.voucher &&
            applicationData?.application_status !== "Completed" &&
            applicationData?.application_status !== "Rejected"
        ) {
            toast.error("Update the application status");
            return;
        }

        if (applicationData?.application_status === "Rejected" && !taskData?.feedback
        ) {
            toast.error("Providing feedback on task submitted is compulsory");
            return;
        }

        const updatedData = {
            ...applicationData,
            destinations: JSON.stringify(selectedDestinations),
        };
        setDisableSaveButton(true)
        const formData = new FormData();

        if (applicationData?.payment_receipt && paymentReceipt) {
            const privateCheck = 0;
            formData.append('file', applicationData?.payment_receipt);
            formData.append('is_private', String(privateCheck));
        }

        try {
            let uploadedFile = null;

            if (formData.has("file")) {
                try {
                    const uploadResponse = await api.post(
                        `https://dash.bestdiplomats.org/api/method/upload_file`,
                        formData,
                        config
                    );

                    uploadedFile = uploadResponse?.data;
                    console.log("Uploaded file response:", uploadedFile);

                    if (uploadedFile?.message?.file_url) {
                        updatedData.payment_receipt = uploadedFile.message.file_url;
                    }
                } catch (uploadErr) {
                    console.error("File upload failed:", uploadErr);
                    toast.error("File upload failed. Please try again.");
                    setDisableSaveButton(false);
                    return;
                }
            }

            const [applicationResponse, taskResponse] = await Promise.all([
                api.put(
                    `https://dash.bestdiplomats.org/api/resource/Scholarship Application Requests/${applicationData.name}`,
                    updatedData,
                    config
                ),
                api.put(
                    `https://dash.bestdiplomats.org/api/resource/Scholarship Task Submission/${taskData.name}`,
                    { feedback: taskData.feedback },
                    config
                )
            ]);

            toast.success("Changes saved successfully!");
            setDisableSaveButton(false);
            navigate(-1);
        } catch (err) {
            console.error(err);
            toast.error("Error saving changes. Please try again.");
            setDisableSaveButton(false);
        }


    }

    return (
        <div className="w-full p-6 space-y-6 bg-gray-50 min-h-screen">
            <div className="flex items-center gap-4">
                <button
                    onClick={() => navigate(-1)}
                    className="text-gray-800 px-3 py-1.5 rounded-lg"
                >
                    ← Back
                </button>
            </div>
            {
                loading ? (
                    <div className="space-y-4 animate-pulse">
                        <div className="h-6 bg-gray-200 rounded w-1/3"></div>
                        <div className="h-4 bg-gray-200 rounded w-2/3"></div>
                        <div className="h-4 bg-gray-200 rounded w-1/2"></div>
                        <div className="h-32 bg-gray-200 rounded"></div>
                    </div>
                ) : (
                    <div>
                        {/* Header */}
                        <div className="flex flex-col gap-4 mb-4">
                            <div className="flex items-center gap-4 justify-between">
                                <h1 className="text-2xl font-semibold">Application Details</h1>
                                <button
                                    onClick={submitChanges}
                                    disabled={disableSaveButton}
                                    className="bg-blue-600 text-white px-4 py-2 rounded-lg text-sm shadow hover:bg-blue-700 transition 
                                    disabled:opacity-50 disabled:cursor-not-allowed"
                                >
                                    Save
                                </button>
                            </div>


                            {/* Action Controls */}
                            <div className="flex flex-wrap items-center gap-4 bg-white shadow rounded-xl p-4 justify-between">
                                {/* Feature Toggle */}
                                <label className="flex items-center gap-2 cursor-pointer text-sm ">
                                    <input
                                        type="checkbox"
                                        checked={applicationData?.featured_application ?? false}
                                        onChange={(e) =>
                                            setApplicationData((prev) => ({
                                                ...prev,
                                                featured_application: e.target.checked,
                                            }))
                                        }
                                        className="w-4 h-4"
                                    />
                                    <span className="text-gray-700">Feature Application</span>
                                </label>

                                {/* Application Status */}
                                <div className="flex flex-row">
                                    <div className="flex flex-col mr-2">
                                        <span className="text-xs text-gray-500 mb-1">Application Status</span>
                                        <select
                                            value={applicationData?.application_status}
                                            onChange={(e) => handleChange(e, "application_status")}
                                            className="border rounded-lg px-6 py-2 text-sm"
                                        >
                                            <option value="">Select Status</option>
                                            {availableStatuses?.map((status) => (
                                                <option key={status} value={status}>
                                                    {status}
                                                </option>
                                            ))}
                                        </select>
                                    </div>

                                    {/* Voucher Code (only when needed) */}
                                    {(applicationData?.application_status === "Conference Selected" ||
                                        applicationData?.application_status === "Completed" ||
                                        applicationData?.application_status === "Rejected") && (
                                            <div className="flex flex-col">
                                                <span className="text-xs text-gray-500 mb-1">Voucher Code</span>
                                                <div className="flex gap-2">
                                                    <input
                                                        type="text"
                                                        value={applicationData?.voucher}
                                                        disabled={originalStatus === 'Completed' || originalStatus === 'Rejected'}
                                                        onChange={(e) => handleChange(e, "voucher")}
                                                        placeholder="Enter voucher code"
                                                        className="border rounded-lg px-3 py-2 text-sm flex-1"
                                                    />
                                                </div>
                                            </div>
                                        )}
                                </div>
                            </div>
                        </div>

                        {/* Applicant Information */}
                        <div className="bg-white shadow rounded-xl p-6 flex flex-col md:flex-row gap-6 mb-4">
                            <PrivateImage imageUrl={userData?.image} className={"w-32 h-32 rounded-lg object-cover"} />

                            <div>
                                <h2 className="text-xl font-semibold">
                                    {userData?.name}
                                </h2>
                                <p className="text-gray-600">{applicationData?.user}</p>
                                <p className="text-gray-600">Institution Name: {applicationData?.institution_name}</p>
                                <p className="text-gray-600">Highest Education: {applicationData?.highest_education}</p>
                                <p className="text-gray-600">Field of Study: {applicationData?.field_of_study}</p>
                                <p className="text-gray-600">Graduation Status: {applicationData?.graduation_status}</p>
                                {
                                    applicationData?.graduation_status === "Graduated" && (
                                        <p className="text-gray-600">
                                            Graduation Date: {applicationData?.graduation_year}
                                        </p>
                                    )
                                }
                                <p className="text-gray-600">English Proficiency: {applicationData?.english_proficiency}</p>
                                <p className="text-gray-600">
                                    Programme: {applicationData?.programme_type}
                                </p>
                                <p className="text-gray-600">
                                    Programme Detail: {applicationData?.programme_detail}
                                </p>
                                <p className="text-gray-600">
                                    Scholarship: {applicationData?.scholarship_type}
                                </p>
                                <a
                                    href={baseUrl + applicationData?.cv}
                                    target="_blank"
                                    rel="noreferrer"
                                    className="text-blue-600 underline mt-2 block"
                                >
                                    View CV
                                </a>
                            </div>
                        </div>

                        {/* Questions and Feedback */}
                        <div className="space-y-6 bg-white shadow rounded-xl p-6 space-y-3 mb-4">
                            <div className="space-y-6">
                                <div className="bg-white shadow rounded-xl p-6 space-y-3">
                                    <strong>Q1. Reason for Participation</strong>
                                    <p className="font-medium">Response: {applicationData?.reason_for_participation}</p>
                                    <textarea
                                        value={applicationData?.reason_for_participation_feedback ?? ""}
                                        onChange={(e) =>
                                            handleFeedbackChange(`reason_for_participation_feedback`, e.target.value)
                                        }
                                        placeholder="Enter feedback..."
                                        className="w-full border rounded-lg p-3"
                                    />

                                </div>
                            </div>

                            <div className="space-y-6">
                                <div className="bg-white shadow rounded-xl p-6 space-y-3">
                                    <strong>Q2. Leadership & Extracurricular Activities</strong>
                                    <p className="font-medium">Response: {applicationData?.leadership_or_extracurricular_activities}</p>
                                    <textarea
                                        value={applicationData?.leadership_or_extracurricular_activities_feedback ?? ""}
                                        onChange={(e) =>
                                            handleFeedbackChange(`leadership_or_extracurricular_activities_feedback`, e.target.value)
                                        }
                                        placeholder="Enter feedback..."
                                        className="w-full border rounded-lg p-3"
                                    />
                                </div>
                            </div>

                            <div className="space-y-6">
                                <div className="bg-white shadow rounded-xl p-6 space-y-3">
                                    <strong>Q3. Impact You Will Create</strong>
                                    <p className="font-medium">Response: {applicationData?.impact_you_will_create}</p>
                                    <textarea
                                        value={applicationData?.impact_you_will_create_feedback ?? ""}
                                        onChange={(e) =>
                                            handleFeedbackChange(`impact_you_will_create_feedback`, e.target.value)
                                        }
                                        placeholder="Enter feedback..."
                                        className="w-full border rounded-lg p-3"
                                    />
                                </div>
                            </div>
                        </div>

                        {/* Financial Information */}
                        <div className="space-y-6 mb-4">
                            <div className="bg-white shadow rounded-xl p-6 space-y-3">
                                <strong>Financial Need</strong>
                                <p className="font-medium">Response: {applicationData?.financial_need}</p>
                            </div>
                        </div>

                        {/* Upload Payment Receipt */}
                        {applicationData?.payment_receipt == null || applicationData?.payment_receipt === "" && (
                            <div className="bg-white shadow rounded-xl p-6 space-y-6 mb-4">
                                <h2 className="text-xl font-semibold mb-4">Upload Payment Receipt</h2>
                                <input
                                    type="file"
                                    accept="image/*,.pdf"
                                    onChange={(e) => {
                                        const file = e.target.files[0];
                                        if (file) {
                                            setApplicationData((prev) => ({ ...(prev ?? {}), payment_receipt: file }));
                                            setPaymentReceipt(true);
                                        }
                                    }}
                                    className="block w-full text-sm text-gray-600 file:mr-4 file:py-2 file:px-4
                                        file:rounded-lg file:border-0 file:text-sm file:font-semibold
                                        file:bg-blue-50 file:text-blue-600 hover:file:bg-blue-100"
                                />
                            </div>
                        )}

                        {/* View Payment Receipt */}
                        {applicationData?.payment_receipt !== null && applicationData?.payment_receipt !== ""
                            && (
                                <div className="bg-white shadow rounded-xl p-6 space-y-6 mb-4">
                                    <div>
                                        <h2 className="text-xl font-semibold mb-2">Payment Receipt</h2>
                                        {applicationData?.payment_receipt ? (
                                            <div className="border rounded-lg p-4">
                                                <a
                                                    href={baseUrl + applicationData.payment_receipt}
                                                    target="_blank"
                                                    rel="noreferrer"
                                                    className="text-blue-600 underline"
                                                >
                                                    {applicationData.payment_receipt.split("/").pop()}
                                                </a>
                                            </div>
                                        ) : (
                                            <p className="text-gray-600">No receipt uploaded yet.</p>
                                        )}
                                    </div>
                                </div>
                            )}

                        {/* Order Number */}
                        {/* {applicationData?.application_status !== "Payment Pending" && originalStatus !== "Payment Pending"
                            && (
                                <div className="bg-white shadow rounded-xl p-6 space-y-6 mb-4">
                                    <div>
                                        <h2 className="text-xl font-semibold mb-2">Order Number</h2>
                                        <p className="text-gray-600">{applicationData?.order_number}</p>
                                    </div>
                                </div>
                            )} */}

                        {/* Order Code Display */}
                        {
                            <div className="bg-white shadow rounded-xl p-6 space-y-6 mb-4">
                                <div>
                                    <h2 className="text-xl font-semibold mb-2">Order Number</h2>
                                    <div className="flex gap-2">
                                                    <input
                                                        type="text"
                                                        value={applicationData?.order_number}
                                                        onChange={(e) => handleChange(e, "order_number")}
                                                        placeholder="Enter order number"
                                                        className="border rounded-lg px-3 py-2 text-sm flex-1"
                                                    />
                                                </div>
                                </div>
                            </div>
                        }

                        {/* Tasks Section */}
                        {taskData?.task && applicationData?.application_status !== "Payment Pending" && (
                            <div className="bg-white shadow rounded-xl p-6 space-y-6 mb-4">
                                {/* Assigned Task */}
                                <div>
                                    <h2 className="text-xl font-semibold mb-4">Assigned Task</h2>
                                    <div className="mb-4">
                                        <p className="font-medium text-lg">{taskData?.task?.title}</p>
                                        <p className="text-gray-600">{taskData?.task?.description}</p>

                                        <div className="mt-3 flex flex-wrap gap-4 text-sm text-gray-600">
                                            <p>
                                                <span className="font-medium">Validity:</span>{" "}
                                                {new Date(taskData?.task?.valid_from).toLocaleDateString()} -{" "}
                                                {new Date(taskData?.task?.valid_till).toLocaleDateString()}
                                            </p>
                                        </div>
                                        <p className=" flex gap-1 text-sm text-gray-600">
                                            <span className="font-medium">Due Date:</span>{" "}
                                            {new Date(taskData?.due_date).toLocaleDateString()}
                                        </p>
                                    </div>

                                    {/* Attachments */}
                                    <h4 className="font-semibold mb-2">Task Attachments</h4>
                                    {taskData?.task?.attachments?.length > 0 ? (
                                        <ul className="space-y-3">
                                            {taskData.task.attachments.map((file, i) => (
                                                <li
                                                    key={i}
                                                    className="border rounded-lg p-4 flex items-center justify-between hover:bg-gray-50 transition"
                                                >
                                                    <div className="flex items-center gap-2">
                                                        <svg
                                                            width="20"
                                                            height="20"
                                                            viewBox="0 0 24 24"
                                                            fill="none"
                                                            className="text-gray-500"
                                                        >
                                                            <path
                                                                d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"
                                                                stroke="currentColor"
                                                                strokeWidth="2"
                                                            />
                                                            <polyline
                                                                points="14,2 14,8 20,8"
                                                                stroke="currentColor"
                                                                strokeWidth="2"
                                                            />
                                                        </svg>
                                                        <a
                                                            href={baseUrl + file?.attachment}
                                                            target="_blank"
                                                            rel="noreferrer"
                                                            className="text-blue-600 underline"
                                                        >
                                                            {file?.attachment.split("/").pop()}
                                                        </a>
                                                    </div>
                                                </li>
                                            ))}
                                        </ul>
                                    ) : (
                                        <p className="text-gray-600">No task attachments found.</p>
                                    )}
                                </div>

                                {/* Submission Section */}
                                <div>
                                    <h2 className="text-xl font-semibold mb-4">Task Submission</h2>
                                    {taskData?.submission_attachment ? (
                                        <div className="border rounded-lg p-4 space-y-2">
                                            <a
                                                href={baseUrl + taskData?.submission_attachment}
                                                target="_blank"
                                                rel="noreferrer"
                                                className="text-blue-600 underline block"
                                            >
                                                {taskData?.submission_attachment.split("/").pop()}
                                            </a>
                                            <p className="text-gray-600 text-sm">
                                                Submitted on:{" "}
                                                {taskData?.submission_date
                                                    ? new Date(taskData.submission_date).toLocaleDateString()
                                                    : "N/A"}
                                            </p>
                                        </div>
                                    ) : (
                                        <p className="text-gray-600">No task submission yet.</p>
                                    )}
                                </div>

                                {/* Feedback Section */}
                                <div>
                                    <h2 className="text-xl font-semibold mb-2">Feedback</h2>
                                    <ReactQuill
                                        theme="snow"
                                        value={taskData?.feedback ?? ""}
                                        onChange={(value) =>
                                            setTaskData((prev) => ({ ...(prev ?? {}), feedback: value }))
                                        }

                                    />
                                </div>
                            </div>
                        )}

                        {(applicationData?.application_status === "Approved" || applicationData?.application_status === "Conference Selected" ||
                            applicationData?.application_status === "Completed") && (
                                <div className="space-y-6 bg-white shadow rounded-xl p-6 mb-4">
                                    <div className="flex flex-col space-y-2">
                                        <span className="text-xs text-gray-500 mb-2">Select Destinations</span>
                                        {destinations?.map((destination) => (
                                            <label key={destination.name} className="flex items-center gap-2">
                                                <input
                                                    type="checkbox"
                                                    checked={!!selectedDestinations.find((d) => d.name === destination.name)}
                                                    disabled={applicationData?.application_status === "Conference Selected" ||
                                                        applicationData?.application_status === "Completed"}
                                                    onChange={() => handleCheckboxChange(destination)}
                                                    className="h-4 w-4"
                                                />
                                                <span>{destination.title}</span>
                                                <span>({destination.start_date} - {destination.end_date})</span>
                                            </label>
                                        ))}
                                    </div>

                                    {selectedDestinations?.length > 0 && (
                                        <div className="space-y-4">
                                            <h3 className="text-sm font-semibold text-gray-700">
                                                Selected Destinations
                                            </h3>
                                            {selectedDestinations?.map((d) => (
                                                <div
                                                    key={d.name}
                                                    className="border rounded-lg p-4 flex flex-col gap-2"
                                                >
                                                    <span className="font-medium">{d.title}</span>
                                                    <div className="flex gap-3">
                                                        <input
                                                            type="number"
                                                            placeholder="Full Accommodation Price"
                                                            disabled={applicationData?.application_status === "Conference Selected" ||
                                                                applicationData?.application_status === "Completed"}
                                                            value={d.accommodation}
                                                            onChange={(e) =>
                                                                handlePriceChange(d.name, "accommodation", e.target.value)
                                                            }
                                                            className="border rounded px-2 py-1 flex-1"
                                                        />
                                                        <input
                                                            type="number"
                                                            placeholder="Non-Accommodation Price"
                                                            disabled={applicationData?.application_status === "Conference Selected" ||
                                                                applicationData?.application_status === "Completed"}
                                                            value={d.non_accommodation}
                                                            onChange={(e) =>
                                                                handlePriceChange(d.name, "non_accommodation", e.target.value)
                                                            }
                                                            className="border rounded px-2 py-1 flex-1"
                                                        />
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </div>
                            )}

                        {(applicationData?.application_status === "Conference Selected" || applicationData?.application_status === "Completed") && (
                            <div className="space-y-6 bg-white shadow rounded-xl p-6 mb-4">
                                <div className="flex flex-col space-y-2">
                                    <span className="text-xs text-gray-500 mb-2">Selected Destination</span>
                                    <span>{applicationData?.selected_destination} - {applicationData?.selected_package}
                                    </span>
                                </div>
                            </div>
                        )}
                    </div>
                )}
        </div >
    )
}
export default ApplicationDetails;